(function(angular) {
	'use strict';
	
	angular
		.module('beneficiaryAlertModule', [
			'coreModule'
		]);
})(window.angular);